var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "nk-menu" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "li",
      { staticClass: "nk-menu-item" },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            class: {
              "is-active":
                _vm.$route.path === "/home" ||
                _vm.$route.path === "/dashboard" ||
                _vm.$route.path === "/",
            },
            attrs: { to: "/dashboard" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--blue" },
              [_c("admin-icon", { attrs: { name: "grid" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "general.dashboard" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("institute_document") &&
              _vm.hasPermission("list-institute-document"),
            expression:
              "moduleMenu && showMenu('institute_document') && hasPermission('list-institute-document')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/institute/document", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--indigo" },
              [_c("admin-icon", { attrs: { name: "file" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "institute.document" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("reception") &&
              _vm.hasAnyPermission([
                "list-enquiry",
                "list-visitor-log",
                "list-postal-record",
                "list-call-log",
                "list-complaint",
                "list-gate-pass",
              ]),
            expression:
              "moduleMenu && showMenu('reception') && hasAnyPermission(['list-enquiry', 'list-visitor-log', 'list-postal-record', 'list-call-log', 'list-complaint', 'list-gate-pass'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-1"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-1")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--cyan" },
              [_c("admin-icon", { attrs: { name: "inbox" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "reception.reception" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-1"] },
            attrs: { id: "collapse-1" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-enquiry") && _vm.showMenu("enquiry")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/reception/enquiry" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chat" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "reception.admission_enquiry",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-visitor-log") &&
              _vm.showMenu("visitor_log")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/reception/visitor/log" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "users" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "reception.visitor_log" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-call-log") && _vm.showMenu("call_log")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/reception/call/log" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "phone" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "reception.call_log" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-postal-record") &&
              _vm.showMenu("postal_record")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/reception/postal/record" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "mail" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "reception.postal_record" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-complaint") && _vm.showMenu("complaint")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/reception/complaint" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "alert" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "reception.complaint" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-gate-pass") && _vm.showMenu("gate_pass")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/reception/gate/pass" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "door-open" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "reception.gate_pass" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-visitor-message") &&
              _vm.showMenu("visitor_message")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/reception/visitor/message" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "send" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "reception.visitor_message" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermission("access-configuration"),
                      expression: "hasPermission('access-configuration')",
                    },
                  ],
                  staticClass: "nk-menu-item",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nk-menu-link",
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        href: "#",
                        "aria-expanded": _vm.nestedModuleMenuConfigOpen
                          .ReceptionConfig
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleNested("ReceptionConfig")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "sliders" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: {
                          "menu-key": "reception.reception_configuration",
                        },
                      }),
                      _vm._v(" "),
                      _c("admin-icon", {
                        staticClass: "admin-nav-chevron",
                        attrs: { name: "chevron" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nk-menu-collapse",
                      class: {
                        "is-open":
                          _vm.nestedModuleMenuConfigOpen.ReceptionConfig,
                      },
                      attrs: { id: "collapse-ReceptionConfig" },
                    },
                    [
                      _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/reception/enquiry/type",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "tag" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "reception.enquiry_type",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/reception/enquiry/source",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "database" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "reception.enquiry_source",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/reception/visiting/purpose",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "map-pin" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "reception.visiting_purpose",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/reception/calling/purpose",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "phone" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "reception.calling_purpose",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/reception/complaint/type",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "alert" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "reception.complaint_type",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("academic") &&
              _vm.hasAnyPermission([
                "list-academic-session",
                "list-course",
                "list-batch",
                "list-class-teacher",
                "list-subject",
                "list-subject-teacher",
                "list-class-timing",
                "list-timetable",
                "list-teacher-timetable",
                "academic-reports",
              ]),
            expression:
              "moduleMenu && showMenu('academic') && hasAnyPermission(['list-academic-session', 'list-course', 'list-batch', 'list-class-teacher', 'list-subject', 'list-subject-teacher', 'list-class-timing', 'list-timetable', 'list-teacher-timetable', 'academic-reports'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-2"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-2")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--violet" },
              [_c("admin-icon", { attrs: { name: "school" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "academic.academic" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-2"] },
            attrs: { id: "collapse-2" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-academic-session") &&
              _vm.showMenu("academic_session")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/academic/session" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "calendar" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "academic.academic_session" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-course") && _vm.showMenu("course")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/academic/course" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "graduation-cap" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "academic.course" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-batch") && _vm.showMenu("batch")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/academic/batch" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "users" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "academic.batch" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-class-teacher") &&
              _vm.showMenu("class_teacher")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/academic/class/teacher" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "user-check" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "academic.class_teacher" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-subject") && _vm.showMenu("subject")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/academic/subject" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "book" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "academic.subject" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-subject-teacher") &&
              _vm.showMenu("subject_teacher")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/academic/subject/teacher" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "pencil" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "academic.subject_teacher" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-class-timing") &&
              _vm.showMenu("class_timing")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/academic/class/timing" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "clock" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "academic.class_timing" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-timetable") && _vm.showMenu("timetable")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/academic/timetable" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "calendar-check" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "academic.timetable" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-teacher-timetable") &&
              _vm.showMenu("teacher_timetable")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/academic/teacher/timetable" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "clipboard-list" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "academic.teacher_timetable" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-certificate") &&
              _vm.showMenu("certificate")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/academic/certificate" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "badge" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "academic.certificate" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("academic-reports") &&
              _vm.showMenu("academic_reports")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/reports/index" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "reports.reports" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermission("access-configuration"),
                      expression: "hasPermission('access-configuration')",
                    },
                  ],
                  staticClass: "nk-menu-item",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nk-menu-link",
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        href: "#",
                        "aria-expanded": _vm.nestedModuleMenuConfigOpen
                          .academic_config
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleNested("academic_config")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "sliders" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: {
                          "menu-key": "academic.academic_configuration",
                        },
                      }),
                      _vm._v(" "),
                      _c("admin-icon", {
                        staticClass: "admin-nav-chevron",
                        attrs: { name: "chevron" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nk-menu-collapse",
                      class: {
                        "is-open":
                          _vm.nestedModuleMenuConfigOpen.academic_config,
                      },
                      attrs: { id: "collapse-academic_config" },
                    },
                    [
                      _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/academic/course/group",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "folder" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "academic.course_group",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/academic/institute",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "building" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "academic.institute" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/academic/institute",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "building" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "academic.institute_other",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/academic/certificate/template",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "file-text" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "academic.certificate_template",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/academic/id-card/template",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "id-card" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "academic.id_card_template",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/academic/print/template",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "printer" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "academic.print_template",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/academic/marksheet/template",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "clipboard-check" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "academic.marksheet_template",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("student") &&
              _vm.hasAnyPermission([
                "list-registration",
                "class-monitor",
                "list-student",
                "edit-roll-number",
                "generate-student-id-card",
                "list-student-attendance",
                "promote-student",
                "terminate-student",
              ]),
            expression:
              "moduleMenu && showMenu('student') && hasAnyPermission(['list-registration', 'class-monitor', 'list-student', 'edit-roll-number', 'generate-student-id-card', 'list-student-attendance', 'promote-student', 'terminate-student'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-3"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-3")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--emerald" },
              [_c("admin-icon", { attrs: { name: "graduation-cap" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", { attrs: { "menu-key": "student.student" } }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-3"] },
            attrs: { id: "collapse-3" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("import-student") &&
              _vm.showMenu("student_import")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/import" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "upload" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.import" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-registration") &&
              _vm.showMenu("registration")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/registration/card-view" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "user-plus" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.registration" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.hasPermission("list-student") ||
                _vm.hasPermission("list-class-teacher-wise-student")) &&
              _vm.showMenu("student_list")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/card-view" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "graduation-cap" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.student_list" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("edit-roll-number") &&
              _vm.showMenu("roll_number")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/roll/number" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "hash" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.roll_number" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("generate-student-id-card") &&
              _vm.showMenu("student_id_card")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/id-card" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "id-card" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.id_card" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("edit-student") &&
              _vm.showMenu("student_image_upload")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/image" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "image" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.image_upload" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-student-attendance") &&
              _vm.showMenu("student_attendance")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/attendance" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "calendar-check" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.attendance" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("promote-student") && _vm.showMenu("promotion")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/promotion" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "trending-up" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.promotion" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("terminate-student") &&
              _vm.showMenu("termination")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/termination" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "user-minus" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.termination" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("edit-student") &&
              _vm.showMenu("student_parent")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/parent" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "users" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.parent" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("edit-student") && _vm.showMenu("student_login")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/login" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "key" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.login" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-student") && _vm.showMenu("student_login")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/qr-code" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "qr-code" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.print_qr" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("class-monitor") &&
              _vm.showMenu("class_monitor")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/class-monitor" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "eye" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.class_monitor" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("counsellor-report") &&
              _vm.showMenu("counsellor_report")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/student/counsellor-report" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.counsellor_report" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermission("access-configuration"),
                      expression: "hasPermission('access-configuration')",
                    },
                  ],
                  staticClass: "nk-menu-item",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nk-menu-link",
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        href: "#",
                        "aria-expanded": _vm.nestedModuleMenuConfigOpen
                          .student_config
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleNested("student_config")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "sliders" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "student.student_configuration" },
                      }),
                      _vm._v(" "),
                      _c("admin-icon", {
                        staticClass: "admin-nav-chevron",
                        attrs: { name: "chevron" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nk-menu-collapse",
                      class: {
                        "is-open":
                          _vm.nestedModuleMenuConfigOpen.student_config,
                      },
                      attrs: { id: "collapse-student_config" },
                    },
                    [
                      _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: { to: "/configuration/student" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "sliders" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "general.general" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: { to: "/configuration/student/group" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "users" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "student.student_group",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/student/document/type",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "file" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "student.document_type_only",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: { to: "/configuration/student/house" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "home" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "student.house" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/student/question",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "help-circle" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "student.student_questions",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/student/favorites",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "heart" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "student.favorites" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/basic", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--blue" },
              [_c("admin-icon", { attrs: { name: "settings" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.basic_configuration" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/social", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--indigo" },
              [_c("admin-icon", { attrs: { name: "share" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.social_network" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/system", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--slate" },
              [_c("admin-icon", { attrs: { name: "sliders" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.system_configuration" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.configMenu &&
              _vm.hasPermission("access-configuration") &&
              _vm.getConfig("multilingual"),
            expression:
              "configMenu && hasPermission('access-configuration') && getConfig('multilingual')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/locale", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--teal" },
              [_c("admin-icon", { attrs: { name: "globe" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.locale" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.configMenu &&
              _vm.hasPermission("access-configuration") &&
              _vm.hasRole("admin"),
            expression:
              "configMenu && hasPermission('access-configuration') && hasRole('admin')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/role", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--violet" },
              [_c("admin-icon", { attrs: { name: "shield" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.role" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.configMenu &&
              _vm.hasPermission("access-configuration") &&
              _vm.hasRole("admin"),
            expression:
              "configMenu && hasPermission('access-configuration') && hasRole('admin')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/permission", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--purple" },
              [_c("admin-icon", { attrs: { name: "lock" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.permission" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/mail", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--indigo" },
              [_c("admin-icon", { attrs: { name: "mail" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.mail_configuration" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/sms", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--emerald" },
              [_c("admin-icon", { attrs: { name: "chat" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.sms_configuration" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/whatsapp", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--emerald" },
              [_c("admin-icon", { attrs: { name: "whatsapp" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.whatsapp_configuration" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/message_template", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--amber" },
              [_c("admin-icon", { attrs: { name: "file-text" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "communication.message_template" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/payment/gateway", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--sky" },
              [_c("admin-icon", { attrs: { name: "card" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "finance.payment_gateway" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/authentication", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--rose" },
              [_c("admin-icon", { attrs: { name: "key" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "auth.authentication" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/menu", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--cyan" },
              [_c("admin-icon", { attrs: { name: "menu" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.menu" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.configMenu && _vm.hasPermission("access-configuration"),
            expression: "configMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/module", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--slate" },
              [_c("admin-icon", { attrs: { name: "layers" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.module_configuration" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-100"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-100")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--cyan" },
              [_c("admin-icon", { attrs: { name: "sliders" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "reception.reception_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-100"] },
            attrs: { id: "collapse-100" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/reception/enquiry/type" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "tag" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "reception.enquiry_type" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/reception/enquiry/source" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "database" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "reception.enquiry_source" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: {
                        to: "/configuration/reception/visiting/purpose",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "map-pin" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "reception.visiting_purpose" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/reception/calling/purpose" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "phone" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "reception.calling_purpose" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/reception/complaint/type" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "alert" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "reception.complaint_type" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-101"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-101")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--violet" },
              [_c("admin-icon", { attrs: { name: "sliders" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "academic.academic_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-101"] },
            attrs: { id: "collapse-101" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/academic/course/group" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "folder" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "academic.course_group" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/academic/institute" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "building" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "academic.institute" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/academic/institute" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "building" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "academic.institute_other" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: {
                        to: "/configuration/academic/certificate/template",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "file-text" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "academic.certificate_template" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/academic/id-card/template" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "id-card" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "academic.id_card_template" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/academic/print/template" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "printer" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "academic.print_template" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: {
                        to: "/configuration/academic/marksheet/template",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [
                          _c("admin-icon", {
                            attrs: { name: "clipboard-check" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "academic.marksheet_template" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-102"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-102")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--emerald" },
              [_c("admin-icon", { attrs: { name: "wallet" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "finance.finance_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-102"] },
            attrs: { id: "collapse-102" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: {
                        to: "/configuration/finance/transaction/category",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "folder" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "finance.transaction_category" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/finance/payment/method" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "wallet" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "finance.payment_method" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-103"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-103")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--emerald" },
              [_c("admin-icon", { attrs: { name: "sliders" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "student.student_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-103"] },
            attrs: { id: "collapse-103" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/student" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "sliders" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "general.general" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/student/group" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "users" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "student.student_group" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/student/document/type" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "file" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "student.document_type_only" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/student/house" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "home" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "student.house" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/student/question" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "help-circle" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "student.student_questions" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/student/favorites" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "heart" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "student.favorites" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-104"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-104")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--pink" },
              [_c("admin-icon", { attrs: { name: "sliders" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "exam.configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-104"] },
            attrs: { id: "collapse-104" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/exam/term" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "calendar" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "exam.term" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/exam/assessment" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [
                          _c("admin-icon", {
                            attrs: { name: "clipboard-check" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "exam.assessment" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/exam/observation" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "eye" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "exam.observation" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/exam/grade" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "star" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "exam.grade" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/exam/remark-rule" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "chat" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "exam.remark_rules" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/exam/result-division-rule" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "layers" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "exam.result_division_rules" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/exam/authority" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "shield" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "exam.authorities" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/exam/marksheet/template" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [
                          _c("admin-icon", {
                            attrs: { name: "clipboard-check" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "academic.marksheet_template" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-105"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-105")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--orange" },
              [_c("admin-icon", { attrs: { name: "briefcase" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "employee.employee_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-105"] },
            attrs: { id: "collapse-105" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/employee" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "briefcase" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "general.general" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/employee/category" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "tag" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "employee.category" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/employee/designation" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "badge" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "employee.designation" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/employee/department" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "building" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "employee.department" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/employee/group" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "users" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "employee.employee_group" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/employee/document/type" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "file" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "employee.document_type_only" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/employee/leave/type" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "calendar" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "employee.leave_type" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/employee/attendance/type" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [
                          _c("admin-icon", {
                            attrs: { name: "calendar-check" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "employee.attendance_type" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/employee/pay/head" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "wallet" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "employee.pay_head" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-106"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-106")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--orange" },
              [_c("admin-icon", { attrs: { name: "bus" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "transport.transport_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-106"] },
            attrs: { id: "collapse-106" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: {
                        to: "/configuration/transport/vehicle/document/type",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "file" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: {
                          "menu-key": "transport.vehicle_document_type_only",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: {
                        to: "/configuration/transport/vehicle/fuel/type",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "drop" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "transport.vehicle_fuel_type" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: {
                        to: "/configuration/transport/vehicle/service/center",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "wrench" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: {
                          "menu-key": "transport.vehicle_service_center_only",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-906"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-906")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--teal" },
              [_c("admin-icon", { attrs: { name: "bed" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "hostel.hostel_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-906"] },
            attrs: { id: "collapse-906" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/hostel/category" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "tag" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "hostel.hostel_category" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-107"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-107")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--violet" },
              [_c("admin-icon", { attrs: { name: "book-open" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "library.library_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-107"] },
            attrs: { id: "collapse-107" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/library" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "book-open" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "general.general" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/library/book/author" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "pencil" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "library.book_author" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/library/book/language" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "languages" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "library.book_language" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/library/book/topic" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "tag" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "library.book_topic" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/library/book/publisher" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "building" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "library.book_publisher" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/library/book/condition" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "check-circle" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "library.book_condition" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-108"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-108")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--rose" },
              [_c("admin-icon", { attrs: { name: "calendar" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "calendar.calendar_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-108"] },
            attrs: { id: "collapse-108" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/calendar/event/type" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "star" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "calendar.event_type" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: {
                        to: "/configuration/calendar/celebration-template",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "spark" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "calendar.celebration_templates" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-109"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-109")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--cyan" },
              [_c("admin-icon", { attrs: { name: "newspaper" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "post.post_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-109"] },
            attrs: { id: "collapse-109" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/post/article/type" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "newspaper" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "post.article_type" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-110"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-110")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--sky" },
              [_c("admin-icon", { attrs: { name: "building" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "asset.asset_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-110"] },
            attrs: { id: "collapse-110" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/asset/building" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "building" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "asset.building" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/asset/room" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "door-open" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "asset.room" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration/custom-field", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--violet" },
              [_c("admin-icon", { attrs: { name: "sliders" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.custom_field" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-111"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-111")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--teal" },
              [_c("admin-icon", { attrs: { name: "globe" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "frontend.frontend_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-111"] },
            attrs: { id: "collapse-111" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/frontend/index" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "globe" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "frontend.frontend" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleConfigMenu && _vm.hasPermission("access-configuration"),
            expression:
              "moduleConfigMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-112"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-112")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--amber" },
              [_c("admin-icon", { attrs: { name: "layers" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "misc.misc_configuration" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-112"] },
            attrs: { id: "collapse-112" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/misc/religion" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "heart" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "misc.religion" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/misc/caste" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "users" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "misc.caste" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/misc/category" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "tag" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "misc.category" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/misc/blood/group" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "droplets" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "misc.blood_group" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/misc/disability/type" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "heart" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "misc.disability_type" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nk-menu-item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nk-menu-link",
                      attrs: { to: "/configuration/misc/medium/instruction" },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "languages" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "misc.medium_instruction" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("employee") &&
              _vm.hasAnyPermission([
                "list-employee",
                "generate-employee-id-card",
              ]),
            expression:
              "moduleMenu && showMenu('employee') && hasAnyPermission(['list-employee', 'generate-employee-id-card'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-4"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-4")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--orange" },
              [_c("admin-icon", { attrs: { name: "briefcase" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "employee.employee" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-4"] },
            attrs: { id: "collapse-4" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("import-employee") &&
              _vm.showMenu("employee_import")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/employee/import" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "upload" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "employee.import" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("employee_list")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/employee/card-view" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "briefcase" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "employee.employee_list" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("generate-employee-id-card") &&
              _vm.showMenu("employee_id_card")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/employee/id-card" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "id-card" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "employee.id_card" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("employee_attendance")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/employee/attendance" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "calendar-check" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "employee.attendance" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("employee_leave")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/employee/leave" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "calendar" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "employee.leave" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("employee_payroll")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/employee/payroll" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "wallet" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "employee.payroll" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermission("access-configuration"),
                      expression: "hasPermission('access-configuration')",
                    },
                  ],
                  staticClass: "nk-menu-item",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nk-menu-link",
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        href: "#",
                        "aria-expanded": _vm.nestedModuleMenuConfigOpen
                          .employee_config
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleNested("employee_config")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "briefcase" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: {
                          "menu-key": "employee.employee_configuration",
                        },
                      }),
                      _vm._v(" "),
                      _c("admin-icon", {
                        staticClass: "admin-nav-chevron",
                        attrs: { name: "chevron" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nk-menu-collapse",
                      class: {
                        "is-open":
                          _vm.nestedModuleMenuConfigOpen.employee_config,
                      },
                      attrs: { id: "collapse-employee_config" },
                    },
                    [
                      _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: { to: "/configuration/employee" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "briefcase" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "general.general" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/employee/category",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "tag" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "employee.category" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/employee/designation",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "badge" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "employee.designation" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/employee/department",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "building" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "employee.department" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: { to: "/configuration/employee/group" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "users" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "employee.employee_group",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/employee/document/type",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "file" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "employee.document_type_only",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/employee/leave/type",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "calendar" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "employee.leave_type" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/employee/attendance/type",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "calendar-check" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "employee.attendance_type",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/employee/pay/head",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "wallet" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "employee.pay_head" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("class_and_meet") &&
              _vm.hasAnyPermission([
                "list-live_classes",
                "list-live_meeting",
                "live_class_report",
                "live_meeting_report",
              ]),
            expression:
              "moduleMenu && showMenu('class_and_meet') && hasAnyPermission(['list-live_classes', 'list-live_meeting', 'live_class_report', 'live_meeting_report'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-zoom"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-zoom")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--rose" },
              [_c("admin-icon", { attrs: { name: "video" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "meet.class_and_meet" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-zoom"] },
            attrs: { id: "collapse-zoom" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-live_classes") &&
              _vm.showMenu("live_classes")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/meet/live-class" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "video" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "meet.live_classes" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-live_meeting") &&
              _vm.showMenu("live_meeting")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/meet/live-meeting" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "video" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "meet.live_meeting" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("live_class_report") &&
              _vm.showMenu("live_class_report")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/meet/live-class/report" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "meet.live_class_report" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("live_meeting_report") &&
              _vm.showMenu("live_meeting_report")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/meet/live-meeting/report" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "meet.live_meeting_report" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("lesson_plan") &&
              _vm.hasAnyPermission([
                "manage-lesson-plan",
                "manage-syllabus-status",
                "lessons",
                "syllabus-topic",
                "subject-lesson-plan-report",
                "syllabus-status-report",
              ]),
            expression:
              "moduleMenu && showMenu('lesson_plan') && hasAnyPermission(['manage-lesson-plan', 'manage-syllabus-status', 'lessons', 'syllabus-topic', 'subject-lesson-plan-report', 'syllabus-status-report'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-lessons"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-lessons")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--indigo" },
              [_c("admin-icon", { attrs: { name: "book-open" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "resource.lesson_plan" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-lessons"] },
            attrs: { id: "collapse-lessons" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("manage-lesson-plan") &&
              _vm.showMenu("manage_lesson_plan")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/lesson-plan/manage-lesson-plan" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "clipboard-list" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "resource.manage_lesson_plan",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("manage-syllabus-status") &&
              _vm.showMenu("manage_syllabus_status")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/lesson-plan/syllabus-status" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "check-circle" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "resource.manage_syllabus_status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("lessons") && _vm.showMenu("lessons")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/lesson-plan/lessons" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "book" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "resource.lessons" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("syllabus-topic") &&
              _vm.showMenu("syllabus_topic")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/lesson-plan/topics" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "tag" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "resource.syllabus_topic" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("subject-lesson-plan-report") &&
              _vm.showMenu("subject_lesson_plan_report")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/lesson-plan/reports/subject-wise" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "resource.subject_lesson_plan_report",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("syllabus-status-report") &&
              _vm.showMenu("syllabus_status_report")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/lesson-plan/reports/status-report" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "clipboard-check" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "resource.syllabus_status_report",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("behaviour_records") &&
              _vm.hasAnyPermission([
                "list-assign-incidents",
                "list-incidents",
                "incidents-report",
              ]),
            expression:
              "moduleMenu && showMenu('behaviour_records') && hasAnyPermission(['list-assign-incidents', 'list-incidents', 'incidents-report'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-incidents"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-incidents")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--amber" },
              [_c("admin-icon", { attrs: { name: "alert" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "incident.behaviour_records" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-incidents"] },
            attrs: { id: "collapse-incidents" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-assign-incidents") &&
              _vm.showMenu("assign_incidents")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/behaviour/assign" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "user-plus" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "incident.assign_incidents" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-incidents") && _vm.showMenu("incidents")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/behaviour/incidents" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "alert" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "incident.incidents" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("incidents-report") &&
              _vm.showMenu("incidents_report")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/behaviour/reports" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "general.report" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("download_center") &&
              _vm.hasAnyPermission([
                "list-content-type",
                "list-content-share-list",
                "iupload-content",
                "video-tutorial",
              ]),
            expression:
              "moduleMenu && showMenu('download_center') && hasAnyPermission(['list-content-type', 'list-content-share-list', 'iupload-content', 'video-tutorial'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-download-center"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-download-center")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--blue" },
              [_c("admin-icon", { attrs: { name: "download" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "download_center.download_center" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: {
              "is-open": _vm.mainAccordionOpen["collapse-download-center"],
            },
            attrs: { id: "collapse-download-center" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-content-type") &&
              _vm.showMenu("content_type")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/download-center/content-type" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "folder" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "download_center.content_type",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-content-share-list") &&
              _vm.showMenu("content_share_list")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/download-center/document-share-list" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "share" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "download_center.content_share_list",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("upload-content") &&
              _vm.showMenu("upload_content")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/download-center/content-list" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "upload" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "download_center.upload_content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("video-tutorial") &&
              _vm.showMenu("video_tutorial")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/download-center/video-tutorial" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "video" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "download_center.video_tutorial",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("qr_attendance") &&
              _vm.hasAnyPermission([
                "qr-take-attendance",
                "qr-attendance-report",
              ]),
            expression:
              "moduleMenu && showMenu('qr_attendance') && hasAnyPermission(['qr-take-attendance', 'qr-attendance-report'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-qr"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-qr")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--purple" },
              [_c("admin-icon", { attrs: { name: "qr-code" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "student.qr_attendance" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-qr"] },
            attrs: { id: "collapse-qr" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("qr-take-attendance") &&
              _vm.showMenu("qr_student_attendance")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/qr/attendance" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "scan" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.attendance" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("qr-attendance-report") &&
              _vm.showMenu("qr_attendance_report")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/qr/attendance-report" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "student.attendance_report" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("exam") &&
              _vm.hasAnyPermission([
                "list-exam-schedule",
                "list-exam-mark",
                "access-exam-report",
                "access-class-teacher-wise-exam-report",
                "list-online-exam",
              ]),
            expression:
              "moduleMenu && showMenu('exam') && hasAnyPermission(['list-exam-schedule', 'list-exam-mark', 'access-exam-report', 'access-class-teacher-wise-exam-report', 'list-online-exam'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-5"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-5")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--pink" },
              [_c("admin-icon", { attrs: { name: "clipboard-check" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", { attrs: { "menu-key": "exam.exam" } }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-5"] },
            attrs: { id: "collapse-5" },
          },
          [
            _c(
              "ul",
              { staticClass: "nk-menu-sub sip-menu-sub" },
              [
                _vm.hasPermission("list-exam-schedule") &&
                _vm.showMenu("exam_schedule")
                  ? _c(
                      "li",
                      { staticClass: "nk-menu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nk-menu-link",
                            attrs: { to: "/exam/schedule" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                              [
                                _c("admin-icon", {
                                  attrs: { name: "calendar" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("menu-item-text", {
                              attrs: { "menu-key": "exam.schedule" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasPermission("list-exam-mark") &&
                _vm.showMenu("exam_record_mark")
                  ? _c(
                      "li",
                      { staticClass: "nk-menu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nk-menu-link",
                            attrs: { to: "/exam/record" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                              [
                                _c("admin-icon", {
                                  attrs: { name: "clipboard-list" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("menu-item-text", {
                              attrs: { "menu-key": "exam.record" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAnyPermission([
                  "access-exam-report",
                  "access-class-teacher-wise-exam-report",
                ]) && _vm.showMenu("exam_report_card")
                  ? _c(
                      "li",
                      { staticClass: "nk-menu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nk-menu-link",
                            attrs: { to: "/exam/report-card-attendance" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                              [
                                _c("admin-icon", {
                                  attrs: { name: "calendar-check" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("menu-item-text", {
                              attrs: {
                                "menu-key": "exam.report_card_attendance",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAnyPermission([
                  "access-exam-report",
                  "access-class-teacher-wise-exam-report",
                ]) && _vm.showMenu("exam_report_card")
                  ? _c(
                      "li",
                      { staticClass: "nk-menu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nk-menu-link",
                            attrs: { to: "/exam/report" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                              [
                                _c("admin-icon", {
                                  attrs: { name: "file-text" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("menu-item-text", {
                              attrs: { "menu-key": "exam.report" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAnyPermission([
                  "access-exam-report",
                  "access-class-teacher-wise-exam-report",
                ]) && _vm.showMenu("exam_report_card")
                  ? _c(
                      "li",
                      { staticClass: "nk-menu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nk-menu-link",
                            attrs: { to: "/exam/result-announcement" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                              [
                                _c("admin-icon", {
                                  attrs: { name: "megaphone" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("menu-item-text", {
                              attrs: { "menu-key": "exam.result_announcement" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasNotAnyRole(["student", "parent"]) &&
                _vm.showMenu("exam_topper_report")
                  ? [
                      _vm.hasAnyPermission([
                        "access-exam-report",
                        "access-class-teacher-wise-exam-report",
                      ])
                        ? _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: { to: "/exam/report/topper" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "trophy" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: { "menu-key": "exam.topper_report" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAnyPermission([
                  "access-exam-report",
                  "access-class-teacher-wise-exam-report",
                ]) && _vm.showMenu("exam_report_analysis")
                  ? _c("li", { staticClass: "nk-menu-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nk-menu-link",
                          staticStyle: { cursor: "pointer" },
                          attrs: {
                            href: "#",
                            "aria-expanded": _vm.nestedModuleMenuConfigOpen
                              .examReportAnalysis
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.toggleNested("examReportAnalysis")
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "exam.report_analysis" },
                          }),
                          _vm._v(" "),
                          _c("admin-icon", {
                            staticClass: "admin-nav-chevron",
                            attrs: { name: "chevron" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "nk-menu-collapse",
                          class: {
                            "is-open":
                              _vm.nestedModuleMenuConfigOpen.examReportAnalysis,
                          },
                          attrs: { id: "collapse-exam-report-analysis" },
                        },
                        [
                          _c(
                            "ul",
                            { staticClass: "nk-menu-sub sip-menu-sub" },
                            [
                              _c(
                                "li",
                                { staticClass: "nk-menu-item" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nk-menu-link",
                                      attrs: { to: "/exam/report/analysis" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "nk-menu-icon nk-menu-icon-sub",
                                        },
                                        [
                                          _c("admin-icon", {
                                            attrs: { name: "chart" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("menu-item-text", {
                                        attrs: {
                                          "menu-key": "exam.report_analysis",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "nk-menu-item" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nk-menu-link",
                                      attrs: {
                                        to: {
                                          path: "/exam/report/analysis/export",
                                          query: { type: "course-group-wise" },
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "nk-menu-icon nk-menu-icon-sub",
                                        },
                                        [
                                          _c("admin-icon", {
                                            attrs: { name: "folder" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("menu-item-text", {
                                        attrs: {
                                          "menu-key":
                                            "exam.course_group_wise_report",
                                          label: "Course Group wise Report",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "nk-menu-item" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nk-menu-link",
                                      attrs: {
                                        to: {
                                          path: "/exam/report/analysis/export",
                                          query: { type: "batch-wise" },
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "nk-menu-icon nk-menu-icon-sub",
                                        },
                                        [
                                          _c("admin-icon", {
                                            attrs: { name: "users" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("menu-item-text", {
                                        attrs: {
                                          "menu-key": "exam.batch_wise_report",
                                          label: "Batch wise Report",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "nk-menu-item" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nk-menu-link",
                                      attrs: {
                                        to: {
                                          path: "/exam/report/analysis/export",
                                          query: { type: "exam-wise" },
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "nk-menu-icon nk-menu-icon-sub",
                                        },
                                        [
                                          _c("admin-icon", {
                                            attrs: { name: "chart" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("menu-item-text", {
                                        attrs: {
                                          "menu-key": "exam.exam_wise_report",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasPermission("list-online-exam") &&
                _vm.showMenu("online_exam")
                  ? _c(
                      "li",
                      { staticClass: "nk-menu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nk-menu-link",
                            attrs: { to: "/online-exam" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                              [
                                _c("admin-icon", {
                                  attrs: { name: "monitor" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("menu-item-text", {
                              attrs: { "menu-key": "exam.online_exam" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasPermission("access-configuration"),
                        expression: "hasPermission('access-configuration')",
                      },
                    ],
                    staticClass: "nk-menu-item",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "nk-menu-link",
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          href: "#",
                          "aria-expanded": _vm.nestedModuleMenuConfigOpen
                            .exam_config
                            ? "true"
                            : "false",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.toggleNested("exam_config")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                          [_c("admin-icon", { attrs: { name: "sliders" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c("menu-item-text", {
                          attrs: { "menu-key": "exam.configuration" },
                        }),
                        _vm._v(" "),
                        _c("admin-icon", {
                          staticClass: "admin-nav-chevron",
                          attrs: { name: "chevron" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "nk-menu-collapse",
                        class: {
                          "is-open": _vm.nestedModuleMenuConfigOpen.exam_config,
                        },
                        attrs: { id: "collapse-exam_config" },
                      },
                      [
                        _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
                          _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: { to: "/configuration/exam/term" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "calendar" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: { "menu-key": "exam.term" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: {
                                    to: "/configuration/exam/assessment",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "clipboard-check" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: { "menu-key": "exam.assessment" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: {
                                    to: "/configuration/exam/observation",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "eye" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: { "menu-key": "exam.observation" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: { to: "/configuration/exam/grade" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "star" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: { "menu-key": "exam.grade" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: {
                                    to: "/configuration/exam/remark-rule",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "chat" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: { "menu-key": "exam.remark_rules" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: {
                                    to: "/configuration/exam/result-division-rule",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "layers" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: {
                                      "menu-key": "exam.result_division_rules",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: {
                                    to: "/configuration/exam/authority",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "shield" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: { "menu-key": "exam.authorities" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: {
                                    to: "/configuration/exam/marksheet/template",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "clipboard-check" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: {
                                      "menu-key": "academic.marksheet_template",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
              2
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("finance") &&
              _vm.hasAnyPermission([
                "list-fee-group",
                "list-fee-head",
                "list-fee-allocation",
                "list-fee-concession",
                "list-account",
                "list-income",
                "list-expense",
                "list-account-transfer",
              ]),
            expression:
              "moduleMenu && showMenu('finance') && hasAnyPermission(['list-fee-group', 'list-fee-head', 'list-fee-allocation', 'list-fee-concession', 'list-account', 'list-income', 'list-expense', 'list-account-transfer'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-6"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-6")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--emerald" },
              [_c("admin-icon", { attrs: { name: "rupee" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", { attrs: { "menu-key": "finance.finance" } }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-6"] },
            attrs: { id: "collapse-6" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-fee-group") && _vm.showMenu("fee_group")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/finance/fee/group" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "folder" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "finance.fee_group" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-fee-head") && _vm.showMenu("fee_head")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/finance/fee/head" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "tag" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "finance.fee_head" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-fee-concession") &&
              _vm.showMenu("fee_concession")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/finance/fee/concession" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "percent" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "finance.fee_concession" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-fee-allocation") &&
              _vm.showMenu("fee_allocation")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/finance/fee/allocation" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "layers" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "finance.fee_allocation" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-account") && _vm.showMenu("account")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/finance/account" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "wallet" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "finance.account" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-income") && _vm.showMenu("income")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/finance/transaction/income" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "trending-up" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "finance.income" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-expense") && _vm.showMenu("expense")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/finance/transaction/expense" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "receipt" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "finance.expense" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-account-transfer") &&
              _vm.showMenu("account_transfer")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: {
                            to: "/finance/transaction/account/transfer",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "refresh" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "finance.account_transfer" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("finance_report")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/finance/report" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "general.report" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermission("access-configuration"),
                      expression: "hasPermission('access-configuration')",
                    },
                  ],
                  staticClass: "nk-menu-item",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nk-menu-link",
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        href: "#",
                        "aria-expanded": _vm.nestedModuleMenuConfigOpen
                          .finance_cofig
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleNested("finance_cofig")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "wallet" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "finance.finance_configuration" },
                      }),
                      _vm._v(" "),
                      _c("admin-icon", {
                        staticClass: "admin-nav-chevron",
                        attrs: { name: "chevron" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nk-menu-collapse",
                      class: {
                        "is-open": _vm.nestedModuleMenuConfigOpen.finance_cofig,
                      },
                      attrs: { id: "collapse-finance_cofig" },
                    },
                    [
                      _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/finance/transaction/category",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "folder" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "finance.transaction_category",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/finance/payment/method",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "wallet" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "finance.payment_method",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("transport") &&
              _vm.hasAnyPermission([
                "list-transport-circle",
                "list-transport-stoppage",
                "list-transport-fee",
                "list-vehicle",
                "list-vehicle-incharge",
                "list-vehicle-document",
                "list-vehicle-log",
                "list-vehicle-service-record",
                "list-vehicle-fuel",
              ]),
            expression:
              "moduleMenu && showMenu('transport') && hasAnyPermission(['list-transport-circle', 'list-transport-stoppage', 'list-transport-fee', 'list-vehicle', 'list-vehicle-incharge', 'list-vehicle-document', 'list-vehicle-log', 'list-vehicle-service-record', 'list-vehicle-fuel'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-26"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-26")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--orange" },
              [_c("admin-icon", { attrs: { name: "bus" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "transport.transport" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-26"] },
            attrs: { id: "collapse-26" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-transport-stoppage") &&
              _vm.showMenu("vehicle")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/stoppage" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "map-pin" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "transport.transport_stoppage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-transport-circle") &&
              _vm.showMenu("vehicle")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/circle" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "route" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "transport.transport_circle" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("transport_route")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/route" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "route" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "transport.route" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-vehicle") && _vm.showMenu("vehicle")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/vehicle" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "bus" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "transport.vehicle" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-transport-fee") &&
              _vm.showMenu("transport_fee")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/fee" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "rupee" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "transport.fee" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-vehicle-incharge") &&
              _vm.showMenu("vehicle_incharge")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/vehicle/incharge" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "user" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "transport.vehicle_incharge" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-vehicle-document") &&
              _vm.showMenu("vehicle_document")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/vehicle/document" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "file" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "transport.document" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-vehicle-fuel") &&
              _vm.showMenu("vehicle_fuel")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/vehicle/fuel" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "drop" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "transport.fuel" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-vehicle-log") &&
              _vm.showMenu("vehicle_log")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/vehicle/log" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "clipboard" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "transport.log" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-vehicle-service-record") &&
              _vm.showMenu("vehicle_service_record")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/vehicle/service/record" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "wrench" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "transport.service_record" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("access-transport-report") &&
              _vm.showMenu("transport_report")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/transport/report" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "general.report" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermission("access-configuration"),
                      expression: "hasPermission('access-configuration')",
                    },
                  ],
                  staticClass: "nk-menu-item",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nk-menu-link",
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        href: "#",
                        "aria-expanded": _vm.nestedModuleMenuConfigOpen
                          .transport_config
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleNested("transport_config")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "bus" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: {
                          "menu-key": "transport.transport_configuration",
                        },
                      }),
                      _vm._v(" "),
                      _c("admin-icon", {
                        staticClass: "admin-nav-chevron",
                        attrs: { name: "chevron" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nk-menu-collapse",
                      class: {
                        "is-open":
                          _vm.nestedModuleMenuConfigOpen.transport_config,
                      },
                      attrs: { id: "collapse-transport_config" },
                    },
                    [
                      _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/transport/vehicle/document/type",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "file" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key":
                                      "transport.vehicle_document_type_only",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/transport/vehicle/fuel/type",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "drop" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "transport.vehicle_fuel_type",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/transport/vehicle/service/center",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "wrench" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key":
                                      "transport.vehicle_service_center_only",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("hostel") &&
              _vm.hasAnyPermission([
                "hostel",
                "list-facilities",
                "list-rooms",
                "list-meal-schedule",
                "list-meal-plan",
                "access-hostel-report",
              ]),
            expression:
              "moduleMenu && showMenu('hostel') && hasAnyPermission(['hostel', 'list-facilities', 'list-rooms', 'list-meal-schedule', 'list-meal-plan', 'access-hostel-report'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-56"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-56")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--teal" },
              [_c("admin-icon", { attrs: { name: "bed" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", { attrs: { "menu-key": "hostel.hostel" } }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-56"] },
            attrs: { id: "collapse-56" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.showMenu("hostel")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/hostel/hostel" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "bed" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "hostel.hostel" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-facilities") && _vm.showMenu("facilities")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/hostel/facilities" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "spark" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "hostel.facilities" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-rooms") && _vm.showMenu("rooms")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/hostel/rooms" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "door-open" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "hostel.rooms" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-rooms") && _vm.showMenu("incharge")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/hostel/incharge" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "user" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "hostel.hostel_incharge" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-meal-schedule") &&
              _vm.showMenu("meal_schedule")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/hostel/meal-schedule" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "calendar" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "hostel.meal_schedule" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-meal-schedule") &&
              _vm.showMenu("food_menu")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/hostel/food-menu" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "utensils" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "hostel.food_menu" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-meal-plan") && _vm.showMenu("meal_plan")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/hostel/meal-plan" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "food" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "hostel.meal_plan" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-meal-plan") && _vm.showMenu("meal_plan")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/hostel/report" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "general.report" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermission("access-configuration"),
                      expression: "hasPermission('access-configuration')",
                    },
                  ],
                  staticClass: "nk-menu-item",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nk-menu-link",
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        href: "#",
                        "aria-expanded": _vm.nestedModuleMenuConfigOpen
                          .hostel_config
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleNested("hostel_config")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "bed" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "hostel.hostel_configuration" },
                      }),
                      _vm._v(" "),
                      _c("admin-icon", {
                        staticClass: "admin-nav-chevron",
                        attrs: { name: "chevron" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nk-menu-collapse",
                      class: {
                        "is-open": _vm.nestedModuleMenuConfigOpen.hostel_config,
                      },
                      attrs: { id: "collapse-hostel_config" },
                    },
                    [
                      _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: { to: "/configuration/hostel/category" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "tag" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "hostel.hostel_category",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("calendar") &&
              _vm.hasAnyPermission(["list-holiday", "list-event"]),
            expression:
              "moduleMenu && showMenu('calendar') && hasAnyPermission(['list-holiday', 'list-event'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-7"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-7")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--rose" },
              [_c("admin-icon", { attrs: { name: "calendar" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "calendar.calendar" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-7"] },
            attrs: { id: "collapse-7" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-holiday") && _vm.showMenu("holiday")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/calendar/holiday" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "sun" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "calendar.holiday" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-event") && _vm.showMenu("event")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/calendar/event" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "star" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "calendar.event" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasAnyPermission([
                "list-birthday",
                "list-anniversary",
                "list-work-anniversary",
              ]) && _vm.showMenu("celebration")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/calendar/celebration/birthday" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "spark" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "calendar.celebration" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("resource") &&
              _vm.hasAnyPermission([
                "list-assignment",
                "list-home-work",
                "list-notes",
                "list-lesson-plan",
                "list-syllabus",
              ]),
            expression:
              "moduleMenu && showMenu('resource') && hasAnyPermission(['list-assignment', 'list-home-work', 'list-notes', 'list-lesson-plan', 'list-syllabus'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-8"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-8")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--amber" },
              [_c("admin-icon", { attrs: { name: "folder-open" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "resource.resource" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-8"] },
            attrs: { id: "collapse-8" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-assignment") && _vm.showMenu("assignment")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/resource/assignment" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "clipboard-list" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "resource.assignment" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-home-work") && _vm.showMenu("home_work")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/resource/home-work" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "pencil" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "resource.home_work" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-notes") && _vm.showMenu("notes")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/resource/notes" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "file-text" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "resource.notes" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-lesson-plan") &&
              _vm.showMenu("lesson_plan")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/resource/lesson/plan" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "book-open" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "resource.curriculum_plan" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-syllabus") && _vm.showMenu("syllabus")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/resource/syllabus" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "list" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "resource.syllabus" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("library") &&
              _vm.hasAnyPermission(["list-book", "issue-book", "return-book"]),
            expression:
              "moduleMenu && showMenu('library') && hasAnyPermission(['list-book', 'issue-book', 'return-book'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-9"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-9")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--violet" },
              [_c("admin-icon", { attrs: { name: "book-open" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", { attrs: { "menu-key": "library.library" } }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-9"] },
            attrs: { id: "collapse-9" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-book") && _vm.showMenu("book")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/library/book" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "book" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "library.book" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("issue-book") && _vm.showMenu("issue_book")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/library/issue" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "upload" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "library.issue" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("return-book") && _vm.showMenu("return_book")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/library/return" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "return" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "library.return" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermission("access-configuration"),
                      expression: "hasPermission('access-configuration')",
                    },
                  ],
                  staticClass: "nk-menu-item",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nk-menu-link",
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        href: "#",
                        "aria-expanded": _vm.nestedModuleMenuConfigOpen
                          .library_config
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleNested("library_config")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                        [_c("admin-icon", { attrs: { name: "book-open" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("menu-item-text", {
                        attrs: { "menu-key": "library.library_configuration" },
                      }),
                      _vm._v(" "),
                      _c("admin-icon", {
                        staticClass: "admin-nav-chevron",
                        attrs: { name: "chevron" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "nk-menu-collapse",
                      class: {
                        "is-open":
                          _vm.nestedModuleMenuConfigOpen.library_config,
                      },
                      attrs: { id: "collapse-library_config" },
                    },
                    [
                      _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: { to: "/configuration/library" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "book-open" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "general.general" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/library/book/author",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "pencil" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "library.book_author" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/library/book/language",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "languages" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "library.book_language",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/library/book/topic",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "tag" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: { "menu-key": "library.book_topic" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/library/book/publisher",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "building" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "library.book_publisher",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "nk-menu-item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nk-menu-link",
                                attrs: {
                                  to: "/configuration/library/book/condition",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nk-menu-icon nk-menu-icon-sub",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "check-circle" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("menu-item-text", {
                                  attrs: {
                                    "menu-key": "library.book_condition",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("inventory") &&
              _vm.hasAnyPermission([
                "list-stock-category",
                "list-stock-item",
                "list-vendor",
                "list-stock-purchase",
                "list-stock-transfer",
              ]),
            expression:
              "moduleMenu && showMenu('inventory') && hasAnyPermission(['list-stock-category', 'list-stock-item', 'list-vendor', 'list-stock-purchase', 'list-stock-transfer'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-10"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-10")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--sky" },
              [_c("admin-icon", { attrs: { name: "box" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "inventory.inventory" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-10"] },
            attrs: { id: "collapse-10" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("list-stock-category") &&
              _vm.showMenu("stock_category")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/inventory/stock/category" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "folder" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "inventory.stock_category" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-stock-item") && _vm.showMenu("stock_item")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/inventory/stock/item" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "box" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "inventory.stock_item" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-vendor") && _vm.showMenu("vendor")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/inventory/vendor" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "truck" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "inventory.vendor" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-stock-purchase") &&
              _vm.showMenu("stock_purchase")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/inventory/stock/purchase" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "cart" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "inventory.stock_purchase" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-stock-transfer") &&
              _vm.showMenu("stock_transfer")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/inventory/stock/transfer" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "refresh" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "inventory.stock_transfer" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("post") &&
              _vm.hasPermission("list-article"),
            expression:
              "moduleMenu && showMenu('post') && hasPermission('list-article')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-11"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-11")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--cyan" },
              [_c("admin-icon", { attrs: { name: "newspaper" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", { attrs: { "menu-key": "post.post" } }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-11"] },
            attrs: { id: "collapse-11" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.showMenu("post_feed")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/post/feed" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "activity" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "post.feed" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("article")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/post/article" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "newspaper" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "post.article" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("communication") &&
              _vm.hasAnyPermission([
                "send-sms",
                "send-email",
                "send-push-notification",
                "list-meeting",
              ]),
            expression:
              "moduleMenu && showMenu('communication') && hasAnyPermission(['send-sms', 'send-email', 'send-push-notification', 'list-meeting'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-12"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-12")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--purple" },
              [_c("admin-icon", { attrs: { name: "megaphone" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "communication.communication" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-12"] },
            attrs: { id: "collapse-12" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.hasPermission("send-sms") && _vm.showMenu("send_sms")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/communication/balance" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "wallet" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "communication.balance" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("communication_history") &&
              _vm.hasAnyPermission([
                "send-sms",
                "send-email",
                "send-push-notification",
              ])
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/communication" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "clock" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "communication.history" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("my_notification")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/communication/notification" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "bell" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "communication.my_notification",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("send-sms") && _vm.showMenu("send_sms")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/communication/sms" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "chat" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "communication.sms" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("send-sms") && _vm.showMenu("send_sms")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/communication/whatsapp" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "whatsapp" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "communication.whatsapp" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("send-email") && _vm.showMenu("send_email")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/communication/email" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "mail" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "communication.email" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("send-push-notification") &&
              _vm.showMenu("send_push_notification")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/communication/push-notification" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "bell" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: {
                              "menu-key": "communication.push_notification",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-meeting") && _vm.showMenu("meeting")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/communication/meeting" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "video" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "communication.meeting" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasPermission("list-meeting") && _vm.showMenu("my_meeting")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/communication/my-meeting" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "video" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "communication.my_meeting" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("frontend") &&
              _vm.hasPermission("configure-frontend"),
            expression:
              "moduleMenu && showMenu('frontend') && hasPermission('configure-frontend')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-13"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-13")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--teal" },
              [_c("admin-icon", { attrs: { name: "globe" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "frontend.frontend" },
            }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-13"] },
            attrs: { id: "collapse-13" },
          },
          [
            _c("ul", { staticClass: "nk-menu-sub sip-menu-sub" }, [
              _vm.showMenu("frontend_page")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/frontend/page" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "file" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "frontend.page" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("frontend_block")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/frontend/block" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "layers" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "frontend.block" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("frontend_menu")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/frontend/menu" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "menu" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "frontend.menu" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("frontend_menu")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/frontend/slider" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [_c("admin-icon", { attrs: { name: "image" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "frontend.slider_image" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMenu("frontend_menu")
                ? _c(
                    "li",
                    { staticClass: "nk-menu-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nk-menu-link",
                          attrs: { to: "/frontend/news" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                            [
                              _c("admin-icon", {
                                attrs: { name: "megaphone" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("menu-item-text", {
                            attrs: { "menu-key": "frontend.news_ticker" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.moduleMenu &&
              _vm.showMenu("utility") &&
              _vm.hasAnyPermission(["access-todo", "access-configuration"]),
            expression:
              "moduleMenu && showMenu('utility') && hasAnyPermission(['access-todo', 'access-configuration'])",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "a",
          {
            staticClass: "nk-menu-link",
            staticStyle: { cursor: "pointer" },
            attrs: {
              href: "#",
              "aria-expanded": _vm.mainAccordionOpen["collapse-14"]
                ? "true"
                : "false",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleMain("collapse-14")
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--slate" },
              [_c("admin-icon", { attrs: { name: "wrench" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", { attrs: { "menu-key": "utility.utility" } }),
            _vm._v(" "),
            _c("admin-icon", {
              staticClass: "admin-nav-chevron",
              attrs: { name: "chevron" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "nk-menu-collapse",
            class: { "is-open": _vm.mainAccordionOpen["collapse-14"] },
            attrs: { id: "collapse-14" },
          },
          [
            _c(
              "ul",
              { staticClass: "nk-menu-sub sip-menu-sub" },
              [
                _vm.hasPermission("access-todo") && _vm.showMenu("todo")
                  ? _c(
                      "li",
                      { staticClass: "nk-menu-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nk-menu-link",
                            attrs: { to: "/utility/todo" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "nk-menu-icon nk-menu-icon-sub" },
                              [
                                _c("admin-icon", {
                                  attrs: { name: "check-circle" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("menu-item-text", {
                              attrs: { "menu-key": "utility.todo" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasPermission("access-configuration")
                  ? [
                      _vm.showMenu("ip_filter")
                        ? _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: { to: "/utility/ip-filter" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "shield" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: { "menu-key": "utility.ip_filter" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "nk-menu-item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nk-menu-link",
                              attrs: { to: "/utility/activity-log" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "nk-menu-icon nk-menu-icon-sub",
                                },
                                [
                                  _c("admin-icon", {
                                    attrs: { name: "clock" },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("menu-item-text", {
                                attrs: { "menu-key": "utility.activity_log" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.featureAvailable("email_template")
                        ? _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: { to: "/utility/email-template" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "mail" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: {
                                      "menu-key": "utility.email_template",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.featureAvailable("email_log")
                        ? _c(
                            "li",
                            { staticClass: "nk-menu-item" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "nk-menu-link",
                                  attrs: { to: "/utility/email-log" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "nk-menu-icon nk-menu-icon-sub",
                                    },
                                    [
                                      _c("admin-icon", {
                                        attrs: { name: "inbox" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("menu-item-text", {
                                    attrs: { "menu-key": "utility.email_log" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "nk-menu-item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nk-menu-link",
                              attrs: { to: "/utility/scheduled-job" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "nk-menu-icon nk-menu-icon-sub",
                                },
                                [
                                  _c("admin-icon", {
                                    attrs: { name: "hourglass" },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("menu-item-text", {
                                attrs: { "menu-key": "utility.scheduled_job" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.moduleMenu && _vm.hasPermission("access-configuration"),
            expression: "moduleMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-heading",
      },
      [
        _c("h6", { staticClass: "overline-title" }, [
          _vm._v("INSTITUTION CONFIG"),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.moduleMenu && _vm.hasPermission("access-configuration"),
            expression: "moduleMenu && hasPermission('access-configuration')",
          },
        ],
        staticClass: "nk-menu-item",
      },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/configuration", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--slate" },
              [_c("admin-icon", { attrs: { name: "settings" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "configuration.configuration" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { staticClass: "nk-menu-item" },
      [
        _c(
          "router-link",
          {
            staticClass: "nk-menu-link",
            attrs: { to: "/change/password", exact: "" },
          },
          [
            _c(
              "span",
              { staticClass: "nk-menu-icon nk-menu-icon--amber" },
              [_c("admin-icon", { attrs: { name: "lock" } })],
              1
            ),
            _vm._v(" "),
            _c("menu-item-text", {
              attrs: { "menu-key": "user.change_password" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("li", { staticClass: "nk-menu-item" }, [
      _c(
        "a",
        {
          staticClass: "nk-menu-link",
          attrs: { href: "#", exact: "" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.logout.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "span",
            { staticClass: "nk-menu-icon nk-menu-icon--red" },
            [_c("admin-icon", { attrs: { name: "logout" } })],
            1
          ),
          _vm._v(" "),
          _c("menu-item-text", { attrs: { "menu-key": "auth.logout" } }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nk-menu-heading" }, [
      _c("h6", { staticClass: "overline-title" }, [
        _vm._v("ACADEMIC WORKSPACE"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nk-menu-heading" }, [
      _c("h6", { staticClass: "overline-title" }, [
        _vm._v("FINANCE & BILLING"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nk-menu-heading" }, [
      _c("h6", { staticClass: "overline-title" }, [
        _vm._v("LOGISTICS & RESOURCES"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nk-menu-heading" }, [
      _c("h6", { staticClass: "overline-title" }, [
        _vm._v("COMMUNICATION & OPS"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }